import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, CircularProgress, Select, MenuItem, FormControl, InputLabel, FormHelperText, Input, Chip, Tooltip, IconButton } from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom'; // Import useParams
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const UpdateOtherPost = () => {
  const { postId } = useParams(); // Get postId from the URL params
  const [positionName, setPositionName] = useState('');
  const [city, setCity] = useState([]);
  const [jobLink, setJobLink] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [positionCategory, setPositionCategory] = useState('');
  const [jobType, setJobType] = useState('');
  const [jobStatus, setJobStatus] = useState('');
  const [jobSuitable, setJobSuitable] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [postData, setPostData] = useState(null);

  // Türkiye'deki şehirlerin listesi
  const cities = [
    "Genel", "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
    "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis",
    "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce",
    "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane",
    "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş", "Karabük", "Karaman",
    "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir", "Kilis", "Kocaeli", "Konya", "Kütahya",
    "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye",
    "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat",
    "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak", "Yurt Dışı"
  ];

  // Pozisyon kategorilerinin listesi
  const positionCategories = [
    "Araştırma Geliştirme (AR-GE)",
    "Geri Ödeme/Pazara Erişim",
    "Klinik Destek/Aplikasyon",
    "Kalite/Belgelendirme/Mevzuat",
    "Lojistik ve Tedarik Zinciri",
    "Pazarlama/Ürün Yönetimi",
    "Satış",
    "Teknik Servis",
    "Teknoloji Yönetimi",
    "Test/Kalibrasyon/Muayene",
    "Üretim",
    "Akademik",
    "Diğer"
  ];
  const handleCityChange = (event) => {
    setCity(event.target.value);
  };


  // Post ID'yi kullanarak veriyi API'den al
  useEffect(() => {
    const fetchPostData = async () => {
      try {
        const response = await axios.post(`https://kariyer.biyomed.net/api/admin/getOtherPostById`, { id: postId }, { withCredentials: true });
        const post = response.data.job_listing;
        setPositionName(post.position_name);
        const cityArray = post.city ? post.city.split(',').map(city => city.trim()) : [];
        setCity(cityArray);
        setJobLink(post.job_link);
        setCompanyName(post.company_name);
        setPositionCategory(post.position_category);
        setJobType(post.job_type);
        setJobStatus(post.job_status);
        setJobSuitable(post.suitable);
      } catch (err) {
        console.error('Veri yüklenirken hata oluştu:', err);
        setError('İş ilanı verisi alınırken bir hata oluştu.');
      }
    };

    if (postId) {
      fetchPostData();
    }
  }, [postId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Inputları kontrol et
    if (!positionName || !city || !jobLink || !companyName || !positionCategory || !jobType) {
      setError('Lütfen tüm alanları doldurun');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const cityString = city.join(', ');
      // API'ye PUT isteği gönder
      const response = await axios.put(`https://kariyer.biyomed.net/api/admin/updateOtherPost/${postId}`, {
        position_name: positionName,
        city: cityString,
        job_link: jobLink,
        company_name: companyName,
        position_category: positionCategory,
        job_type: jobType,
        job_status: jobStatus,
        suitable: jobSuitable,
      }, { withCredentials: true });

      // Başarılı yanıt durumunda
      console.log('Post updated:', response.data);
      alert("İlan başarıyla güncellendi");
      window.location.href = "/admin/other-posts"; // Yönlendirme
    } catch (err) {
      console.error('İş ilanı güncellenirken bir hata oluştu:', err);
      setError('İş ilanı güncellenirken bir hata oluştu.');
      const errorMessage = err.response?.data?.message || "Bilinmeyen bir hata oluştu. Lütfen tekrar denemeden önce çıkış yapıp tekrar admin girişi yapınız.";
      alert(`Güncelleme işlemi başarısız: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };


  return (
    <Box sx={{ maxWidth: 400, margin: '0 auto', padding: 2 }}>
      <h2>İş İlanını Güncelle</h2>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Pozisyon Adı"
          fullWidth
          value={positionName}
          onChange={(e) => setPositionName(e.target.value)}
          margin="normal"
          required
        />
        <FormControl fullWidth margin="normal" required>
          <InputLabel>Şehir</InputLabel>
          <Select
            multiple
            value={city}
            onChange={handleCityChange}
            input={<Input />}
            renderValue={(selected) => {
              // Eğer selected bir dizi değilse, boş bir dizi olarak kabul et
              const selectedCities = Array.isArray(selected) ? selected : [];
              return (
                <div>
                  {selectedCities.map((value) => (
                    <Chip key={value} label={value} sx={{ margin: 0.5 }} />
                  ))}
                </div>
              );
            }}

            label="Şehir"
          >
            {cities.map((cityName, index) => (
              <MenuItem key={index} value={cityName}>
                {cityName}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>Bir şehir seçin</FormHelperText>
        </FormControl>
        <TextField
          label="İş İlanı Linki"
          fullWidth
          value={jobLink}
          onChange={(e) => setJobLink(e.target.value)}
          margin="normal"
          required
        />
        <TextField
          label="Şirket Adı"
          fullWidth
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          margin="normal"
          required
        />
        <FormControl fullWidth margin="normal" required>
          <InputLabel>Pozisyon Kategorisi</InputLabel>
          <Select
            value={positionCategory}
            onChange={(e) => setPositionCategory(e.target.value)}
            label="Pozisyon Kategorisi"
          >
            {positionCategories.map((category, index) => (
              <MenuItem key={index} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>Bir kategori seçin</FormHelperText>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>İlan Türü</InputLabel>
          <Select
            name="job_type"
            value={jobType}
            onChange={(e) => setJobType(e.target.value)}
          >
            <MenuItem value="Staj">Staj ilanı</MenuItem>
            <MenuItem value="Is">İş ilanı</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ mt: 5 }} fullWidth>
          <InputLabel>İlan Durumu</InputLabel>
          <Select
            name="job_status"
            value={jobStatus}
            onChange={(e) => setJobStatus(e.target.value)}
          >
            <MenuItem value="0">❌ Pasif</MenuItem>
            <MenuItem value="1">✅ Aktif</MenuItem>
            <MenuItem value="2">🗑️ Gereksiz</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ mt: 5 }} fullWidth>
          <InputLabel>
            İlanın biyomedikal mühendis için uygunluğu{" "}
            <Tooltip
              title="Bu ayarı değiştirmek sadece sistemin otomatik olarak LinkedIn paylaşımını etkileyecektir. Uygun degil seciminizde Ilan durumu otomatik olarak Gereksiz olacaktir"
              enterTouchDelay={0}
              leaveTouchDelay={5000}
            >
              <IconButton size="small" sx={{ ml: 1 }}>
                <InfoOutlinedIcon fontSize="medium" />
              </IconButton>
            </Tooltip>
          </InputLabel>
          <Select
            name="job_status"
            value={jobSuitable}
            onChange={(e) => {
              if (e.target.value === "0") {
                setJobStatus(2);
              } 
              setJobSuitable(e.target.value); // seçimi güncellemek için
            }}
          >
            <MenuItem value="0">❌ Uygun Değil</MenuItem>
            <MenuItem value="1">✅ Uygun</MenuItem>
          </Select>
        </FormControl>
        {error && <Box color="error.main" marginY={1}>{error}</Box>}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ marginTop: 2 }}
        >
          {loading ? <CircularProgress size={24} /> : 'İlanı Güncelle'}
        </Button>
      </form>
    </Box>
  );
};

export default UpdateOtherPost;
